var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-searchbar",class:{ fixed: _vm.isFixed }},[(_vm.showFilters)?_c('FiltersToggle'):_vm._e(),_vm._v(" "),_c('SearchBar',{attrs:{"show-wrapper-border":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }